import React, { useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { ChequeCultureLegacy } from "../../legacyforms/ChequeCultureLegacy";
import { ClapService } from "../../../service/ClapService";
import { LinkProviderService } from "../../../service/LinkProviderService";
import "../../../layout/styles/inline-cgos.css";
import './FormulaireCesu.scss';
import {Accordion, AccordionTab} from "primereact/accordion";


import { useDispatch, useSelector } from "react-redux";
import {
  setFiche,
  setIban,
  setMaxVal,
  setOptJustificatif,
  setPac,
  setParamsEnfants
} from "../../../store/actions/actionSociale";
import { ActionSocialeService } from "../../../service/ActionSocialeService";
import { AgentService } from "../../../service/AgentService";
import { ChequeCultureService } from "../../../service/ChequeCultureService";

export const CesuNoticeInformation = ({ mode, hiddenNoticeButton, onConfirm, displayErrors }) => {
  const errors = {
    dod: 1,
    statut: 2,
    qf: 2,
    iban: 3,
    pac: 4,
    exercice:5,
    droits:6,
    siDossierValide:7
  };

  const user = useSelector((state) => state.usager.user);
  const actionSociale = useSelector((state) => state.actionSociale);
  const [currentActionSociale, setCurrentActionSociale] = useState({});
  const [baremes, setBaremes] = useState([]);
  const [valParticipation, setValParticipation] = useState(0);
  const [valMaxParticipation, setValMaxParticipation] = useState(0);
  const [enfants, setEnfants] = useState([]);
  const [paramEnfant, setParamEnfant] = useState({});
  const [displayBasic, setDisplayBasic] = useState(false);
  const [isJustificatifRequis, setIsJustificatifRequis] = useState();
  const [ibanMembre, setIbanMembre] = useState(null);
  const [enfantsAgeIntervalle, setEnfantsAgeIntervalle] = useState({});
  const [displayError, setDisplayError] = useState([]);
  const [activeIndex, setActiveIndex] = useState([]);

  const [hiddenButton, hideButton] = useState(hiddenNoticeButton);
  const dispatch = useDispatch();
  const history = useHistory();

  const actionSocialeService = new ActionSocialeService();
  const clapService = new ClapService();
  const agentService = new AgentService();
  const chequeCultureService = new ChequeCultureService();

  const linkService = new LinkProviderService();

  const  textAdressezVous="Pour en savoir plus ou si vous pensez qu'il y a une erreur, adressez-vous à votre ";


  useEffect(() => {

        getIbanMembre();
        getIsJustificatifRequis();
        getCurrentActionSociale();
      setActiveIndex([0]);
  }, []);
  
  useEffect(() => {
    dispatch(setOptJustificatif(isJustificatifRequis));
  }, [isJustificatifRequis]);

  useEffect(() => {
     dispatch(setMaxVal(valParticipation));
  }, [valParticipation]);

  useEffect(() => {
    dispatch(setIban(ibanMembre));
  }, [ibanMembre]);

  useEffect(() => {
    dispatch(setPac(enfants));
  }, [enfants]);

  useEffect(() => {
    dispatch(setParamsEnfants(paramEnfant));
  }, [paramEnfant]);

  const getFiche =  (actionSocial) => {
      agentService.getFicheAgent(user.numCgos, actionSocial.exercice).then((fiche) => {
          getBaremes(actionSocial,fiche.data);
      });
   }

  const getBaremes = async (actionSocial,fiche) => {
          const bareme = {
            casCode: actionSocial.codeActionSociale,
            exercice: actionSocial.exercice
          };

          try {
            const { data } = await clapService.getBaremesCesu(bareme);
            setBaremes(data);
            let valMax = 0;
            let val = 0;
            data.forEach((el, i) => {
                        if (valMax !== 0) return;
                        if(fiche != null && fiche.quotientFamilial == null){
                                   setValMaxParticipation(data[data.length-1].plafond);
                                   setValParticipation(data[data.length-1].valeur);
                                   valMax = data[data.length-1].plafond;
                                   val = data[data.length-1].valeur;
                                  return;
                         }
                        if (i === data.length - 1) {
                          if (Number(fiche.quotientFamilial.replace(",", ".")) >= Number(el.borne)) {
                            valMax = data[i].plafond;
                            val = data[i].valeur;
                          }
                        } else if (Number(fiche.quotientFamilial.replace(",", ".")) < Number(data[i + 1].borne)) {
                          valMax = el.plafond;
                          val = el.valeur;
                        }
            });
            setValMaxParticipation(valMax);
            setValParticipation(val);
            getIntervalleEnfantsCesu(actionSocial,val,valMax);
          } catch (error) {
            console.log(error);
          }
        };

  const getIntervalleEnfantsCesu = async (actionSocial,valMin,valMax) => {
          const param = {
            casCode: actionSocial.codeActionSociale,
            delegId: actionSocial.codeDelegation,
            exercice: actionSocial.exercice
          };

          try {
            const { data } = await clapService.getIntervalleEnfantsCesu(param);
            setEnfantsAgeIntervalle(data);
            setParamEnfant({"ageMin":data.minValue,"ageMax":data.maxValue,"montantMin":valMin,"montantMax":valMax,"siDoubleCalculMontant": data.doubleCalculEnfantCouplHosp});
          } catch (error) {
            console.log(error);
          }
  };

  const getCurrentActionSociale = () => {
    Object.values(actionSociale.listActionsSociale).forEach((as) => {
      if (
        as.codeActionSociale === actionSociale.cas &&
        as.exercice === actionSociale.exercice
      ) {
        setCurrentActionSociale(as);
        getFiche(as)
        return;
      }
    });
  };




  const getIsJustificatifRequis = async () => {
    try {
      const { data } = await chequeCultureService.getJustificatifRequis();
      setIsJustificatifRequis(data);
    } catch (error) {
      console.log(error);
    }
  };

  //Récuperation de l'IBAN de l'agent
  const getIbanMembre = async () => {
    try {
      const { data } = await clapService.getIbanMembre(user.numCgos);
      setIbanMembre(data.numIBan);
      if(!actionSociale.fiche.siDodEncours){
       if(!data.numIBan && !displayError.includes(errors.iban)) setDisplayError(prevState => [...prevState, errors.iban]);
      }
    } catch (error) {
      setDisplayError(prevState => [...prevState, errors.iban])
    }
  };



  const nextStep = () => {
    actionSocialeService.persistState(actionSociale);
    onConfirm(false);
    hideButton(true);
  };

  const getDateFormat = (date) => {
    return new Date(date).toLocaleDateString("fr-FR", {});
  };

  return (
    <div className="grid">
      <ChequeCultureLegacy />
      <div className="col-12 mx-auto">
        <div className="no_shadow_no_border card " style={{ display: !displayBasic ? "block" : "none" ,fontSize: "10.0pt",fontFamily: "Tahoma, sans-serif"}}>
          <Accordion activeIndex={[0,1,2,3,4,5,6,7]} multiple onTabChange={(e) => setActiveIndex(e.index)} >
            <AccordionTab headerClassName="cgos-h3" header=" Quel est le service rendu ?">
            <p className="cld-p">
              <span>
                 Le Chèque Emploi Service Universel (CESU) Garde d'Enfants permet de payer directement et simplement un salarié ou un organisme pour la garde d'un enfant.
              
                <br/><br/>
                Le montant des CESU est préfinancé en totalité par le C.G.O.S. Vous n'avez rien à payer.
                <br/><br/>
                Si la garde de votre enfant coûte plus chère que le montant des CESU préfinancés, vous pourrez compléter avec un autre moyen de paiement de votre choix.
                <br/><br/>
                Vous avez le choix entre deux formats:
                <br/>
                <ul>
                  <li><b>CESU</b> papier sous forme de carnets de chèques.</li>
                  <li><b>e-CESU</b>, version dématérialisée utilisable depuis un smartphone ou un ordinateur.</li>
              </ul>
                
              </span>
            </p>

            

            <br/>
            <div class="astuce-box-warning">
              <strong>Astuce choix du format</strong><br/>
              Avant d’envoyer votre demande, vérifiez quel est le format des CESU (papier ou e-CESU) 
              accepté par l’organisme (crèche publique notamment) ou par la personne employée.
            </div>
            <p className="cld-p">
              <span>       
                <br/><br/>
                 <b>Durée de validité:</b>  de la date de réception jusqu'au 31 janvier de l’année suivante.
                 <br/>
                 <b>En fin de validité:</b>  il pourra être échangé contre des titres de même valeur.
              </span>
            </p>
            </AccordionTab>
            <AccordionTab headerClassName="cgos-h3" header="Quels sont les modes de gardes acceptés">
              <p className="cld-p">
                <span>
                
                Seules les <b>gardes d'enfants payantes</b> peuvent être rémunérées avec des CESU papier ou des e-CESU.
                <br/><br/>
                <ul>
                  <li>Les services et établissements publics ou privés assurant l’accueil des enfants,</li>
                  <li>Les services d’accueil collectif recevant des enfants scolarisés avant et après la classe,</li>
                  <li>Les associations et entreprises agréées,</li>
                  <li>Les assistantes maternelles,</li>
                  <li>Les personnes employées directement par les particuliers.</li>
                </ul>
                </span>
              </p>
            </AccordionTab>

            <AccordionTab headerClassName="cgos-h3" header="Suis-je concerné ?">
              <p className="cld-p">
                <span>
                <p>
                Oui si vous êtes, 
                <br/>
                 <ul>
                    <li>Un <b>agent en activité</b> ou un <b>retraité de la fonction publique hospitalière</b> ayant ses droits ouverts pour l’année en cours.</li>
                 </ul>
                <br/>
                Mon enfant :
                <br/>
                <ul>
                  <li>Doit être à ma charge fiscale ou en résidence alternée.</li>
                  <li>Doit avoir entre 0 ans et moins de {enfantsAgeIntervalle.maxValue} ans au 31 décembre de l’année {actionSociale.exercice}.</li>
                  <li>S'il est en situation de handicap, avec un taux supérieur ou égal à 80%, il peut bénéficier de la prestation sans limite d’âge. Au-delà de {enfantsAgeIntervalle.maxValue-1} ans il bénéficiera du barème des {enfantsAgeIntervalle.minValue +1 } - {enfantsAgeIntervalle.maxValue-1} ans.</li>
                </ul>
                </p>
                </span>
              </p>
            </AccordionTab>
            <AccordionTab headerClassName="cgos-h3" header="Quand et à quelles conditions puis-je faire une demande ?" disabled={false}>
              <p className="cld-p">
                <span>
                  <p>Les demandes de CESU ou de e-CESU sont possibles uniquement s’il reste du budget disponible. Elles seront ensuite refusées.
                  <p>Vous devez avoir envoyé votre dossier C.G.O.S de l’année en cours.</p>
                  Votre demande est sera étudiée après l'ouverture de vos droits.</p>
                 
                </span>
              </p>
            </AccordionTab>
            <AccordionTab headerClassName="cgos-h3" header="Quand mes CESU arriveront-ils ?" disabled={false}>
              <p className="cld-p">
                <span>
                  <p>Le C.G.O.S passe les commandes 4 fois par an.</p>
                  
                  <p>Les CESU papier sont envoyés directement à votre domicile.
                  <br/>
                  <ul>
                  <li>commande d'avril : réception <b>fin avril / début mai.</b></li>
           
                  <li>commande de juillet : réception <b>fin juillet / début août.</b></li>
               
                  <li>commande d'octobre : réception <b>fin octobre / début novembre</b></li>
                
                  <li>commande de décembre : réception <b>fin décembre / début janvier.</b></li>
                  </ul>
                  </p>
                  
                  <p>Les e-CESU sont crédités sur le compte en ligne dans les 15 jours suivant la commande du C.G.O.S. Les identifiants sont envoyés par email.</p>
                </span>
              </p>
            </AccordionTab>
            <AccordionTab headerClassName="cgos-h3" header="Comment est calculée la prestation ?" disabled={false}>
              <p className="cld-p">
                <span>
                  <p>Le montant de la prestation dépend de l'âge de votre enfant et de votre quotient familial C.G.O.S.
                  <br/>
                  Si vous êtes en couple avec un agent hospitalier, le montant de la prestation est doublé.
                  <br/><br/>
                  </p>
                </span>
              </p>

              {!((displayError.includes(errors.exercice) || displayError.includes(errors.droits) || displayError.includes(errors.dod) || displayError.includes(errors.siDossierValide)) ) && (
                  <table className="cld-table-2">
                <thead>
                  <tr>
                    <th style={{backgroundColor: '#dddcdd', color: '#000'}}>Mon quotient familial</th>
                    <th style={{backgroundColor: '#dddcdd', color: '#000'}}>Enfant âgé de 0 à {enfantsAgeIntervalle.minValue} ans</th>
                    <th style={{backgroundColor: '#dddcdd', color: '#000'}}>Enfant âgé de {enfantsAgeIntervalle.minValue +1 }  à {enfantsAgeIntervalle.maxValue-1} ans</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {actionSociale.fiche.quotientFamilial == null? "non connu" : actionSociale.fiche.quotientFamilial.toString().replace('.', ',')}
                    </td>
                    <td>
                      {baremes.length > 0 && actionSociale.fiche.quotientFamilial == null ? baremes[baremes.length-1].valeur : valParticipation} €
                    </td>
                    <td>
                      {baremes.length > 0 && actionSociale.fiche.quotientFamilial == null ? baremes[baremes.length-1].plafond : valMaxParticipation} €
                    </td>
                  </tr>
                </tbody>
              </table>
              )}
              <p className="cld-p">
                <span>
                  Le tableau de référence :
                </span>
              </p>
              <table className="cld-table">
                <thead>
                  <tr>
                    <th style={{backgroundColor: '#eaf8fb', color: '#000'}}>Tranches de quotient familial de référence</th>
                    <th style={{backgroundColor: '#eaf8fb', color: '#000'}}>Enfant âgé de 0 à {enfantsAgeIntervalle.minValue} ans</th>
                    <th style={{backgroundColor: '#eaf8fb', color: '#000'}}>Enfant âgé de {enfantsAgeIntervalle.minValue +1 }  à {enfantsAgeIntervalle.maxValue-1} ans</th>
                  </tr>
                </thead>
                <tbody>
                  {baremes.map((el, i) => {
                    let borne = "";
                    if (i >= 0 && i < baremes.length - 1) {
                      const borneToNumber = Number(baremes[i + 1].borne).toFixed(0);
                      borne = `de ${el.borne} à ${borneToNumber}`;
                    } else {
                      borne = `supérieur à ${Number(el.borne).toFixed(
                        0
                      )} ou non connu`;
                    }
                    return (
                      <tr key={i}>
                        <td>{borne}</td>
                        <td>{el.valeur} €</td>
                        <td>{el.plafond} €</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </AccordionTab>

            {isJustificatifRequis && (
            <AccordionTab headerClassName="cgos-h3" header="Quel(s) document(s) dois-je préparer ?" disabled={false}>
                <div class="card-justificatif" style={{backgroundColor: '#fff2d6', borderLeft: '5px solid #b38600'}}>
                  <div class="card-justificatif-body">
                    <div class="card-justificatif-img" style={{width: "13%", marginRight: "1%"}}>
                      <img src="/assets/image/DOC-gris.png" title="Bulletin de paie ou attestation de travail" alt="Icon Bulletin de paie ou attestation de travail"/>
                    </div>
                    <div class="card-justificatif-txt-container" style={{width: "85%", color: 'black', fontFamily: 'sans-serif'}}>
                      <div class="card-justificatif-titre pt-2">
                        <span style={{fontSize: '10pt', fontFamily: 'Tahoma, sans-serif'}}>
                          Justificatif de présence en établissement
                        </span>
                      </div>
                      <div class="card-justificatif-description">
                        <span style={{fontSize: '9pt', fontFamily: 'Tahoma, sans-serif'}}>
                          Bulletin de paie ou attestation de travail de moins d’un mois ou décision administrative de congés parental à 100%.
                          <br></br>
                          <br></br>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

              <div className="tutorial">
                <img className="tutorial-image" src="/assets/icon_youtube.png" title="Icone youtube" alt="icon youtube"/>{" "}
                <a
                  target="_blank"
                  href="https://www.youtube.com/watch?v=rQzzWn7Yz-o"
                >
                  <span
                    style={{
                      color:"black",
                      textDecoration: "underline"
                    }}
                  >
                    # TutorielCGOS - Comment scanner un document
                  </span>
                </a>
              </div>
            </AccordionTab>)}



            <AccordionTab headerClassName="cgos-h3" header="Les grandes étapes de la demande" disabled={false}>
              <p className="cld-c">
                <ol>
                  <span>
                    <li style={{marginBottom: '1%'}}>
                    Je choisis le <b>format CESU papier ou e-CESU.</b>
                    </li>
                    <li style={{marginBottom: '1%'}}>
                    Je sélectionne l'enfant concerné par la demande.
                    </li>
                    <li style={{marginBottom: '1%'}}>
                    Je signe électroniquement et j'envoie ma demande via l'Espace agent.
                    </li>
                    <li style={{marginBottom: '1%'}}>
                    Avant la fin du trimestre en cours le C.G.O.S valide ou refuse ma demande.
                    </li>
                    <li style={{marginBottom: '1%'}}>
                    Si ma demande est validée, les CESU sont fabriqués en avril, juillet, octobre ou décembre.
                    </li>
                    <li style={{marginBottom: '1%'}}>
                    <b>Je reçois mes CESU en mai, août, novembre ou janvier.</b>
                    </li>
                  </span>
                </ol>
              </p>

            </AccordionTab>
          </Accordion>
          
          <div class="astuce-box-success mt-3">
            <strong>INFO</strong> : Demander cette prestation prend <strong>moins de 3 minutes</strong>
          </div>
          {!hiddenButton && (
            <div>
              <br></br>
              <div className="next-button-wrapper">
                 { displayErrors.length > 0
                                 ? <button type="button" className="btn_submit_modal" disabled style={{ pointerEvents: "none" }}> DEMANDER CETTE PRESTATION </button>
                                 : <button type="button" className="btn_submit_modal" style={{borderColor: "#999898"}} onClick={nextStep}> DEMANDER CETTE PRESTATION </button>}
              </div>
              <br></br>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
